import { Tooltip } from '@do/walrus';
import { Table, TruncateText } from '@do/walrus';
import * as React from 'react';
import styled from 'styled-components';
import { getSoftwareIncluded } from '../../selectors';
import { isDroplet } from '../../utils';
import copy from '../copy';

const softwareIncludedConfig = {
  columns: [
    {
      header: {
        title: 'Package'
      },
      flex: 2,
      render: ({ website, name }) => {
        return website ? (
          <a href={website} target="_blank" rel="noopener noreferrer">
            <TruncateText>{name}</TruncateText>
          </a>
        ) : (
          <TruncateText>{name}</TruncateText>
        );
      }
    },
    {
      header: {
        title: 'Version'
      },
      render: ({ releaseNotes, version }) => {
        return releaseNotes ? (
          <a href={releaseNotes} target="_blank" rel="noopener noreferrer">
            <TruncateText>{version}</TruncateText>
          </a>
        ) : (
          <TruncateText>{version}</TruncateText>
        );
      }
    },
    {
      header: {
        title: 'License'
      },
      flex: 3,
      render: ({ licenseLink, licenseType }) => {
        const isGithubLink = licenseLink?.includes('github.com');
        const modifiedLicenseType = isGithubLink
          ? `${licenseType} on GitHub`
          : licenseType;

        return licenseLink ? (
          <a href={licenseLink} target="_blank" rel="noopener noreferrer">
            <TruncateText>{modifiedLicenseType}</TruncateText>
          </a>
        ) : (
          <TruncateText>{modifiedLicenseType}</TruncateText>
        );
      }
    }
  ]
};

interface Props {
  app: any;
  isInIframe?: boolean;
}

const TitleContainer = styled.h2`
  display: flex;
  align-items: center;
`;

const SoftwareIncluded: React.FC<Props> = ({ app, isInIframe = false }) => {
  const softwareIncluded = getSoftwareIncluded(app);

  if (!softwareIncluded || !(softwareIncluded.length > 0)) {
    return null;
  }

  return (
    <>
      <TitleContainer>
        <span>Software Included</span>
        {isDroplet(app) && (
          <Tooltip.Help content={copy.appDetails.softwareIncludedTooltip} />
        )}
      </TitleContainer>
      <Table
        small={isInIframe}
        medium={!isInIframe}
        config={softwareIncludedConfig}
        items={softwareIncluded.map(
          ({
            name,
            website,
            version,
            release_notes: releaseNotes,
            license_link: licenseLink,
            license_type: licenseType
          }) => {
            return {
              name,
              website,
              version,
              releaseNotes,
              licenseLink,
              licenseType
            };
          }
        )}
      />
    </>
  );
};

export default SoftwareIncluded;
